import CloudFrontSettingsTab from './cloudfront-settings';
export default CloudFrontSettingsTab;